import { api } from '../../../api';

export interface TorUploadRequest {
  fileName: string;
  base64File: string;
  mimeType: string;
  fileSize: number;
}

export interface TorSpecificationRequest {
  torSpecification: string | null;
}

export interface TorDocumentResponse {
  id: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
  objectKey: string;
  bucket: string;
  uploadedAt: string;
}

// Upload TOR document
export const uploadTorDocument = async (tenderId: string, data: TorUploadRequest): Promise<TorDocumentResponse> => {
  const response = await api.post(`/tenders/${tenderId}/tor-doc`, data);
  return response.data;
};

// Update TOR specification (WYSIWYG content)
export const updateTorSpecification = async (tenderId: string, data: TorSpecificationRequest): Promise<any> => {
  const response = await api.patch(`/tenders/${tenderId}/tor-spec`, data);
  return response.data;
};

// Get TOR document info
export const getTorDocument = async (tenderId: string): Promise<TorDocumentResponse> => {
  const response = await api.get(`/tenders/${tenderId}/tor-doc`);
  return response.data;
};

export const deleteTorDocument = async (tenderId: string): Promise<{ message: string }> => {
  const response = await api.delete(`/tenders/${tenderId}/tor-doc`);
  return response.data;
};

export const downloadTorDocument = async (tenderId: string): Promise<Blob> => {
  const response = await api.get(`/tenders/${tenderId}/tor-doc/download`, {
    responseType: 'blob',
  });
  return response.data;
}; 